import aspectRatio from 'calculate-aspect-ratio';
import fitAspect from 'fit-aspect-ratio';

const getSuggestedDimension = (item, fixedDimensions) => {
  const { width, height } = item;
  if (width && height) {
    const { width: fixedW, height: fixedH } = fixedDimensions;
    const ratio = aspectRatio(width, height);
    const { width: suggestedWidth, height: suggestedHeight } = fitAspect({
      ratio,
      width: fixedW,
      height: fixedH,
    });
    return { width: suggestedWidth, height: suggestedHeight };
  }
  return { width: 0, height: 0 };
};

export default getSuggestedDimension;
